import axios from 'axios'
import { decrypt } from './crypto';

// Function to safely get token from localStorage
const getTokenFromStorage = () => {
  try {
    const storedData = localStorage.getItem('userData');
    if (storedData) {
      const userData = JSON.parse(decrypt(storedData));
      return userData?.auth_token;
    }
    return null;
  } catch (error) {
    // If decryption fails (e.g., config not loaded), return null
    console.warn('Could not decrypt stored auth token:', error.message);
    return null;
  }
};

// Set config defaults when creating the instance
export const api = axios.create({ withCredentials: true, baseURL: process.env.REACT_APP_BASE_URL });

// Request interceptor to dynamically add auth token
api.interceptors.request.use(function (config) {
  const token = getTokenFromStorage();
if (token) {
    config.headers.Authorization = `Bearer ${token}`;
}
  return config;
}, function (error) {
  return Promise.reject(error);
});

api?.interceptors?.response.use(function (response) {
  return response;
}, function (error) {
  if (error?.response?.status === 401) {
     window.location.href = "/login";
     localStorage.removeItem('userData')
  }
  return Promise.reject(error);
});